/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_ThrillerInputs */

const en_header_trending_thriller = /** @type {(inputs: Header_Trending_ThrillerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead the zombie dance`)
};

/**
* | output |
* | --- |
* | "Lead the zombie dance" |
*
* @param {Header_Trending_ThrillerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_thriller = /** @type {((inputs?: Header_Trending_ThrillerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_ThrillerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_thriller(inputs)
});
export { header_trending_thriller as "header.trending.thriller" }